import { z } from "zod";


export const dashboardPanelSchema = z.object({
  name: z.string().min(1,"O nome é obrigatório"),
});

export type TDashBoardPanelForm = z.infer<typeof dashboardPanelSchema>;
